<template>
  <a-modal
    :visible="visible"
    :title="title"
    class="import-translation-modal"
    :getContainer="false"
    width="60%"
    @cancel="handleCancel"
  >
    <div class="form_tab result">
      <div>
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          v-bind="layout"
        >
          <a-form-model-item label="源语言">
            <span style="margin-right: 20px;">{{
              data.main_langset_name
            }}</span>
          </a-form-model-item>
          <a-form-model-item
            ref="a_langset_id"
            label="目标语言"
            prop="a_langset_id"
            :help="formErr.a_langset_id"
            :validateStatus="
              !formErr.a_langset_id || formErr.a_langset_id == '' ? '' : 'error'
            "
            class="seachsboxss"
            style="position: relative;"
          >
            <a-select
              v-model="form.a_langset_id"
              @change="optionLangsetChange"
              mode="multiple"
              class="seachs"
              allowClear
              dropdownClassName="seachsSelectBatchTranslation"
            >
              <a-select-option :value="0">
                <p>全选</p>
              </a-select-option>
              <a-select-option
                :value="item.id"
                :key="item.id" v-for="item in data.langset"
                :class="{
                  activeOption: optionLangsetId.indexOf(item.id) >= 0
                }"
              >
                <p>{{ item.name }}</p>
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="">
            <a-upload
              :file-list="fileList"
              :before-upload="beforeUpload"
              :remove="handleRemove"
              name="file"
            >
              <a-button class="upload" type="primary">上传</a-button>
            </a-upload>
          </a-form-model-item>
        </a-form-model>
        <p class="tips" style="margin-bottom: 20px;">
          请选择.xlsx或.xls格式文件，若无已导出的关键词文件，<a :href="`${this.$store.state.urlExper}/batch_template/导入翻译.xlsx`" target="_blank">请下载空白Excel文件</a>
        </p>
        <a-alert
          :message="
            data.friendly_tips ||
            '友情提示：翻译比较多内容时可能需要一些时间，请您耐心等待！'
          "
          type="warning"
          show-icon
        />
      </div>
    </div>

    <template #footer>
      <div style="text-align: center;">
        <a-button key="back" @click="onSubmit" type="primary">确定</a-button>
        <a-button key="submit" @click="handleCancel">取消</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import API from "./api";
import axios from "axios";
import { validator } from "@/utils/utils";

export default {
  name: "importTranslateModal",
  props: {
    title: {
      type: String,
      default: "导入翻译"
    },
  },
  data() {
    return {
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 }
      },
      headers: { Authorization: window.sessionStorage.getItem("signature") },
      data: {},
      visible: false,
      optionLangsetId: [],
      a_langset_id_copy: [],
      a_customer_id: "",
      type: "",
      form: {
        a_langset_id: []
      },
      formErr: {
        a_langset_id: ""
      },
      rules: {
        a_langset_id: [
          { required: true, message: "请选择目标语言 ", trigger: "change" },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.a_langset_id);
            },
            trigger: "blur"
          }
        ]
      },
      fileList: []
    };
  },
  mounted() {},
  watch: {},
  methods: {
    open(customer_id, type) {
      this.a_customer_id = customer_id;
      this.type = type;
      this.visible = true;
      API.service
        .AI_IMPORT_LINK_TRANSLATE({
          a_customer_id: customer_id
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.data = res.data.data;
          }
        });
    },
    onSubmit() {
      let _that = this;
      _that.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // type 1 产品分类，3 新闻列表，5 案例列表， 13 产品
          let langsetArr = JSON.parse(JSON.stringify(_that.form.a_langset_id));
          if (langsetArr.includes(0)) {
            langsetArr.splice(
              langsetArr.findIndex((item) => {
                return item == 0;
              })
            );
          }
          let sendData = {
            a_customer_id: _that.a_customer_id,
            a_langset_ids: langsetArr,
            type: _that.type,
            file: _that.fileList[0]
          };
          _that.optionLangsetId.push(_that.form.a_langset_id);

          let formData = new FormData();
          formData.append("a_customer_id", sendData.a_customer_id);
          langsetArr.map((item) => {
            formData.append("a_langset_ids[]", item);
          });
          formData.append("type", sendData.type);
          formData.append("file", sendData.file);
          axios
            .post(
              this.$store.state.urlExper +
                "/translation/BatchTranslation/aiImportLinkTranslatePost",
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: window.sessionStorage.getItem("signature")
                }
              }
            )
            .then((res) => {
              if (res.data.code == 500) {
                _that.$message.destroy();
                _that.$message.error(res.data.msg);
              } else if (res.data.code == 200) {
                _that.$emit("importFinsh", {
                  success_num: res.data.data.success_num,
                  fail_num: res.data.data.fail_num,
                  fail_file_url:
                    `${_that.$store.state.urlExper}/` +
                    res.data.data.fail_file_url
                });
                _that.handleCancel();
              }
            });
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.form = {
        a_langset_id: []
      };
      this.fileList = [];
      this.$refs.ruleForm.resetFields();
    },
    beforeUpload(file) {
      this.fileList = [file];
      return false;
    },
    handleRemove(file) {
      this.fileList = [];
    },
    optionLangsetChange(value, option) {
      if (value.length == this.data.langset.length) {
        if (!value.includes(0)) {
          //所有语种都选中
          this.form.a_langset_id = [...value, 0];
        }
      }
      //当前点击的全选
      if (value.includes(0) && !this.a_langset_id_copy.includes(0)) {
        //选过单语种，点击全选
        this.form.a_langset_id = this.data.langset.map((item) => {
          return item.id;
        });
        this.form.a_langset_id = [...this.form.a_langset_id, 0];
      } else {
        //取消全选
        if (!value.includes(0) && this.a_langset_id_copy.includes(0)) {
          this.form.a_langset_id = [];
        } else {
          if (value.includes(0)) {
            this.form.a_langset_id.splice(
              this.form.a_langset_id.findIndex((item) => {
                return item == 0;
              })
            );
          }
        }
      }
      this.a_langset_id_copy = this.form.a_langset_id;
      let langsetNum;
      if (this.a_langset_id_copy.length > 0) {
        if (this.a_langset_id_copy.includes(0)) {
          langsetNum = this.a_langset_id_copy.length - 1;
        } else {
          langsetNum = this.a_langset_id_copy.length;
        }
      } else {
        langsetNum = 1;
      }
    }
  }
};
</script>

<style scoped>
p {
  margin-bottom: 0;
}
.upload {
  margin-left: 30px;
}
</style>
